export default "__VITE_ASSET__79b73852__"